module.exports = __webpack_public_path__ + "static/media/ALIANZA BRA-08.52aee95f.png";